import React, { memo } from "react";
import styled, { keyframes } from "styled-components";

interface ILoaderStyle {
  size?: string;
  position?: string;
}

const spinner = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const LoaderSpinnerContainer = styled.div<ILoaderStyle>`
  position: ${(props) => (props.position === "fixed" ? "fixed" : "absolute")};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 30;
`;

const LoaderSpinner = styled.div<ILoaderStyle>`
  position: absolute;
  border: ${(props) => (props.size === "large" ? "20px" : "10px")} solid #f3f3f3;
  border-top: ${(props) => (props.size === "large" ? "20px" : "10px")} solid
    ${(props) => props.theme.primaryColor};
  border-radius: 50%;
  width: ${(props) => (props.size === "large" ? "200px" : "100px")};
  height: ${(props) => (props.size === "large" ? "200px" : "100px")};
  animation: ${spinner} 2s linear infinite;
`;

const LoaderDef = (props: ILoaderStyle) => {
  return (
    <LoaderSpinnerContainer data-test="spinner" position={props.position}>
      <LoaderSpinner size={props.size} />
    </LoaderSpinnerContainer>
  );
};
export const Loader = memo(LoaderDef);
